import type * as Stitches from '@stitches/react';
import { keyframes, styled } from '@gbm-tech/styles';

export const SidebarItemMenuContainer = styled('nav', {
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
});

const ItemContainerLG: Stitches.CSS = {
  gap: '1.2rem',

  '.arrow': {
    padding: '0.32rem',
  },
};

const ItemContainerXL: Stitches.CSS = {
  gap: '1.4rem',

  span: {
    fontSize: '1.8rem',
    lineHeight: '3.2rem',
  },
};

const ItemContainerXXL: Stitches.CSS = {
  gap: '1.6rem',
};

const ItemContainerHover: Stitches.CSS = {
  backgroundColor: '#eceef2',
};

export const ItemContainer = styled('button', {
  padding: '1.2rem 1.6rem 1.2rem 2.2rem',

  display: 'flex',
  alignItems: 'center',
  gap: '1.4rem',

  backgroundColor: 'white',
  border: 'none',
  outline: 'none',

  cursor: 'pointer',
  transition: 'all ease-in-out 0.4s',

  '.icon': {
    size: '2.4rem',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    color: '#404a59',

    transition: 'all ease-in-out 0.4s',

    svg: {
      size: '100%',
    },

    img: {
      size: '100%',
    },
  },

  '> span': {
    flex: 1,

    textAlign: 'left',
    fontSize: '1.6rem',
    lineHeight: '2.8rem',
    fontWeight: 400,

    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    color: '#404a59',
  },

  '.arrow': {
    size: '2.4rem',
    padding: '0.4rem',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    color: '#404a59',

    backgroundColor: 'transparent',
    border: '1px solid #dae0e7',
    borderRadius: '4px',

    svg: {
      size: '100%',

      transition: 'transform 0.2s',
    },

    '&.is-open': {
      svg: {
        transform: 'rotate(90deg)',
      },
    },
  },

  '&:hover': { ...ItemContainerHover },

  '@lg': { ...ItemContainerLG },

  '@xl': { ...ItemContainerXL },

  '@xxl': { ...ItemContainerXXL },
});

export const SidebarItemMenuCollapsedContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  '& + &': {
    marginTop: '1.6rem',
  },

  '> button': {
    backgroundColor: 'transparent',
    border: 'none',
    outline: 'none',
  },
});

const ItemCollapsedContainerHover: Stitches.CSS = {
  backgroundColor: '#eceef2',
  border: '1px solid #dae0e7',

  '.icon': {
    color: '#404a59',
  },
};

const ItemCollapsedContainerXXL: Stitches.CSS = {
  size: '4.9rem',
  padding: '0.8rem',
};

export const ItemCollapsedContainer = styled('div', {
  position: 'relative',
  size: '4.8rem',
  padding: '1rem',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  backgroundColor: 'white',
  border: '1px solid #dae0e7',
  borderRadius: '100%',

  cursor: 'pointer',
  transition: 'all ease-in-out 0.4s',

  '.icon': {
    size: '100%',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    color: '#404a59',

    '> svg': {
      size: '100%',
    },
  },

  '&:hover': { ...ItemCollapsedContainerHover },

  '@xxl': { ...ItemCollapsedContainerXXL },
});

export const SubItemCollapsedContainerXXL: Stitches.CSS = {
  '> strong': {
    fontSize: '1.4rem',
    lineHeight: '2.4rem',
  },
};

export const SubItemCollapsedContainer = styled('nav', {
  padding: '0.2rem 0',

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'left',
  alignItems: 'left',

  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',

  backgroundColor: 'white',

  '> strong': {
    padding: '0.8rem 2.4rem',

    fontWeight: 500,
    fontSize: '1.2rem',
    lineHeight: '2rem',
    color: '$gray400',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    userSelect: 'none',
  },

  '@xxl': { ...SubItemCollapsedContainerXXL },
});

const dropdownH = keyframes({
  '0%': { opacity: 0, maxHeight: 0 },
  '100%': { opacity: 1, maxHeight: '20rem' },
});

export const SubItemsContainer = styled('div', {
  flexDirection: 'column',
  overflow: 'hidden',

  animationDuration: '300ms',
  animationTimingFunction: 'linear',
  animationName: dropdownH.toString(),

  variants: {
    visible: {
      true: {
        display: 'flex',
      },

      false: {
        display: 'none',
      },
    },
  },
});
